export interface ApiResponse<T> {
    data: T;
    status: number;
    message: string;
}

// Define a utility function to make API calls
export async function apiCall<T>(
    url: string,
    headers: Record<string, string> = {
        'Content-Type': 'application/json'
    },
    method: 'GET' | 'POST' | 'PUT' | 'DELETE' = 'GET',
    body?: Record<string, any>,
    returnBlob?: boolean
): Promise<ApiResponse<T>> {
    try {
        const options: RequestInit = {
            method,
            headers,
            body: body ? JSON.stringify(body) : undefined,
        };

        const response = await fetch(url, options);

        // Check if the response was successful (status code 2xx)
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        if (returnBlob) {
            const blob = await response.blob() as T;
            return {
                data: blob,
                status: response.status,
                message: 'Success',
            };
        }

        const data = await response.json() as T;

        return {
            data,
            status: response.status,
            message: 'Success',
        };
    } catch (error) {
        return {
            data: {} as T,
            status: 500,
            message: (error as Error).message,
        };
    }
}